// Any change to a project the screen shows arrives as one live event naming the project (and the task, if it was
// one): fetch those again. The event says which, not what changed, so nothing can be read from it by the wrong person.
import { useQueryClient } from "@tanstack/react-query";
import { useLiveEvent } from "../../lib/live";
import { projectKeys } from "../../lib/projects";

export function useProjectEvents(slug: string) {
  const qc = useQueryClient();
  useLiveEvent((e) => {
    if (e.type !== "project.changed") return;
    const id = String(e.projectId);
    void qc.invalidateQueries({ queryKey: projectKeys.all(slug) });
    void qc.invalidateQueries({ queryKey: projectKeys.mine(slug) });
    void qc.invalidateQueries({ queryKey: projectKeys.one(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.tasks(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.activity(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.overview(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.milestones(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.meetings(slug, id) });
    void qc.invalidateQueries({ queryKey: projectKeys.files(slug, id) });
    if (e.taskId) void qc.invalidateQueries({ queryKey: projectKeys.task(slug, String(e.taskId)) });
  });
}
